import React, { Component } from 'react';
import FormHeader from "./FormHeader"
import FormStep1 from "./FormStep1RateAssistance"
import FormStep2Feedback from "./FormStep2Feedback"
import FormSupportQualityFeedback from "./FormSupportQualityFeedback";
import FormOtherFeedback from "./FormOtherFeedback";
import FormThankYou from "./FormThankYou";
import FormExpired from "./FormExpired";
import FormHelpfulFeedback from "./FormHelpfulFeedback";
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import FormSupportQualityFeedbackSelection from "./FormSupportQualityFeedbackSelection";



class Form extends Component {
    state = {
        step: 0,
        toggle: "",
        disappointmentReason: "",
        supportDisappointmentReason: "",
        resolution: null,
        resolutionDetails: "",
        disappointmentComment: "",
        helpfulFeedback: "",
        ticketID: null,
        agentName: "",
        validation: false

    }
    componentDidMount() {
        let token = localStorage.getItem('authToken');
        const pathName = window.location.pathname;
        if(pathName.length < 2){
            this.setState({step: 6});
        }
        let uuid = pathName.slice(1);
        let dataToSend = {
            uuid: uuid
        }
        if (!token) {
            const apiUrl = `/api/get`;
             axios.post(apiUrl, dataToSend, {
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then(response => {
                    token = response.data;
                    localStorage.setItem('authToken', token)
                    this.setStateByToken(token);
                })
                .catch(error => {
                    if (error.response) {
                        const status = error.response.status;
                        console.log(status);
                        if (status === 403) {
                            this.setState({step: 7});
                            console.log(error)
                        } else {
                            this.setState({step: 6});
                            console.log(error)
                        }
                    }else{
                        this.setState({step: 6});
                        console.log(error)
                    }
                });


        }else {
            this.setStateByToken(token);
        }
    }

    async fetchData () {
        try {
            let dataToSend = {
                ticket_id: this.state.ticketID,
                rating: this.state.toggle,
                disappointmentReason: this.state.disappointmentReason,
                disappointmentComment: this.state.disappointmentComment,
                helpfulFeedback: this.state.helpfulFeedback,
                supportReason: this.state.supportDisappointmentReason
            }
            let token = localStorage.getItem('authToken');
            if(!token){
                throw new Error('Missing token');
            }
            axios.post(`/api/submit`, dataToSend, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            })
                .then(response => { 
                })
                .catch(error => {
                    console.log(error)
                });
        } catch (error) {
            console.error('Error:', error);
        }
    }
    setStateByToken = (token) => {
        let decodedToken = jwtDecode(token, false);
        this.setState({
            step: 1,
            ticketID: decodedToken.ticket_id,
            agentName: decodedToken.agent
        });
    }

    nextStep = (selectedStep = false) => {
        const { step } = this.state
        if(!selectedStep){
        this.setState({
            step: step + 1
        })
        }else{
            this.setState({
                step: selectedStep
            })
        }
    }

    nextStepHelpful = () => {
        const { step } = this.state
        this.setState({
            step: 5
        })
    }

    prevStep = (selectedStep = false) => {
        const { step } = this.state
        if(!selectedStep) {
            this.setState({
                step: step - 1
            })
        }else{
            this.setState({
                step: selectedStep
            })
        }
    }

    handleEmojiButtonToggle = (button) => {
        this.setState({toggle:button});
    }

    handleFormButtonToggle = (key, value) => {
        this.setState({
            [key]: value
        });
    }

    handleValidationTrigger = (value) => {
        this.setState({
                validation: value
        })
    }

    handleFormTextChange = (key, value) => {
        if(value.length < 2000) {
            this.setState({
                [key]: value
            });
        }
    }

     onSubmit = async (withoutComment = false) => {
        if(withoutComment){
            this.state.disappointmentComment = "";
        }

        await this.fetchData();
        this.setState({
            step: 6
        })
        localStorage.removeItem('authToken');
    }


    render() {
        const screenDimensions = window.screen.availWidth;
        const {step, toggle, disappointmentReason, resolution, resolutionDetails, agent, disappointmentComment, ticketID, agentName, helpfulFeedback, validation, supportDisappointmentReason} = this.state;
        const inputValues = {toggle, screenDimensions, disappointmentReason, resolution, resolutionDetails, agent, disappointmentComment, ticketID, agentName, helpfulFeedback, validation, supportDisappointmentReason}
        var body =  "";
        var header = "";

        switch (step) {
            case 0:
                header = <div></div>
                body = <div></div>
            break;
            case 1:
                header = <FormHeader/>
                body = <FormStep1
                    nextStep={this.nextStep}
                    helpfulStep={this.nextStepHelpful}
                    handleTextChange = {this.handleFormTextChange}
                    handleButtonToggle={this.handleEmojiButtonToggle}
                    inputValues = {inputValues}
                />;
                break;
            case 2:
                header = <FormHeader
                    step = {step}
                />
                body = <FormStep2Feedback
                    nextStep={this.nextStep}
                    prevStep={this.prevStep}
                    onSubmit={this.onSubmit}
                    handleButtonToggle={this.handleFormButtonToggle}
                    handleTextChange = {this.handleFormTextChange}
                    inputValues = {inputValues}
                />;
                break;
            case 3:
                header = <FormHeader
                    step = {step}
                />
                body = <FormSupportQualityFeedback
                    nextStep={this.nextStep}
                    prevStep={this.prevStep}
                    onSubmit={this.onSubmit}
                    handleTextChange = {this.handleFormTextChange}
                    handleValidationTrigger = {this.handleValidationTrigger}
                    inputValues = {inputValues}
                />;
                break;
            case 4:
                header = <FormHeader
                    step = {step}
                />
                body = <FormOtherFeedback
                    nextStep={this.nextStep}
                    prevStep={this.prevStep}
                    onSubmit={this.onSubmit}
                    handleTextChange = {this.handleFormTextChange}
                    handleValidationTrigger = {this.handleValidationTrigger}
                    inputValues = {inputValues}
                />;
                break;

            case 5:
                header = <FormHeader
                    step = {step}
                />
                body = <FormHelpfulFeedback
                    nextStep={this.nextStep}
                    prevStep={this.prevStep}
                    onSubmit={this.onSubmit}
                    handleTextChange = {this.handleFormTextChange}
                    inputValues = {inputValues}
                />;
                break;

            case 6:
                header = null;
                body = <FormThankYou
                />;
                break;
            case 7:
                header = null;
                body = <FormExpired
                />;
                break;
            case 8:
                header = <FormHeader
                    step = {step}
                />
                body = <FormSupportQualityFeedbackSelection
                    nextStep={this.nextStep}
                    prevStep={this.prevStep}
                    onSubmit={this.onSubmit}
                    handleButtonToggle={this.handleFormButtonToggle}
                    handleTextChange = {this.handleFormTextChange}
                    inputValues = {inputValues}
                />;
                break;

        }
        return (
            <div className="container">
                {header}
                {body}
            </div>
        );

    }
}

export {Form};